import { App } from 'vue'
import PhoneInput from './LpPhoneInput.vue'

PhoneInput.install = (Vue: App) => {
  Vue.component(PhoneInput.name, PhoneInput)
}

export default PhoneInput
